import React, { ReactNode } from 'react';

interface TableProps {
  children: ReactNode;
  className?: string;
}

export const Table: React.FC<TableProps> = ({ children, className = '' }) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <table className={`min-w-full divide-y divide-gray-200 ${className}`}>
        {children}
      </table>
    </div>
  );
};

interface TableHeaderProps {
  children: ReactNode;
}

export const TableHeader: React.FC<TableHeaderProps> = ({ children }) => {
  return (
    <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
      <tr>{children}</tr>
    </thead>
  );
};

interface TableHeaderCellProps {
  children: ReactNode;
  className?: string;
}

export const TableHeaderCell: React.FC<TableHeaderCellProps> = ({
  children,
  className = ''
}) => {
    return (
      <th className={`px-3 sm:px-6 py-3 sm:py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider ${className}`}>
        {children}
      </th>
    );
};

interface TableBodyProps {
  children: ReactNode;
}

export const TableBody: React.FC<TableBodyProps> = ({ children }) => {
  return <tbody className="bg-white divide-y divide-gray-200">{children}</tbody>;
};

interface TableRowProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  onClick,
  className = ''
}) => {
  const baseClasses = 'transition-colors duration-150';
  const hoverClasses = onClick ? 'hover:bg-red-50 cursor-pointer' : 'hover:bg-gray-50';
  const finalClasses = `${baseClasses} ${hoverClasses} ${className}`;

  if (onClick) {
    return (
      <tr onClick={onClick} className={finalClasses}>
        {children}
      </tr>
    );
  }

  return <tr className={finalClasses}>{children}</tr>;
};

interface TableCellProps {
  children: ReactNode;
  className?: string;
}

export const TableCell: React.FC<TableCellProps> = ({
  children,
  className = ''
}) => {
    return (
      <td className={`px-3 sm:px-6 py-3 sm:py-4 text-sm text-gray-900 ${className}`}>
        {children}
      </td>
    );
};

